import dsr from "./modules/dsr";

export default { dsr };
